export default __webpack_public_path__ + "static/media/PEPPERCORN.3f40c414.svg";